import {connect, IConnectProps} from 'globx-react';
import * as React               from 'react';
import {Subject}                from 'rxjs';

import StoreName              from '../../../../State/Shared/Constants/StoreName';
import Playback               from '../../../../State/Stores/Playback/Playback';
import * as TestIds           from '../../../Shared/Constants/TestIds';
import IUiEventsStreamPayload from '../../../Shared/Interfaces/IUiEventsStreamPayload';
import composeTokenList       from '../../Util/composeTokenList';
import renderTestId           from '../../Util/renderTestId';
import CaptionsMenuButton     from '../CaptionsMenuButton';
import CurrentTime            from '../CurrentTime';
import Fullscreen             from '../Fullscreen';
import LiveIndicator          from '../LiveIndicator';
import Timecode               from '../Timecode';
import Timeline               from '../Timeline';
import VolumeControl          from '../VolumeControl';

import * as styles from './bar.css';

interface IBarProps extends IConnectProps<Playback> {
    areControlsIdle: boolean;
    isSettingsOpen: boolean;
    uiEvents$: Subject<IUiEventsStreamPayload>;
}

@connect(StoreName.PLAYBACK)
class Bar extends React.Component<IBarProps> {
    public shouldComponentUpdate(nextProps: IBarProps): boolean {
        return (
            nextProps.value.playbackStatus !== this.props.value.playbackStatus ||
            nextProps.areControlsIdle !== this.props.areControlsIdle ||
            nextProps.isSettingsOpen !== this.props.isSettingsOpen
        );
    }

    public render(): JSX.Element {
        const {isLoading, isUnloaded, hasErrored} = this.props.value;
        const {uiEvents$, value, areControlsIdle, isSettingsOpen} = this.props;

        if (isLoading || isUnloaded || hasErrored || isSettingsOpen) return null;

        const {isLiveOrLinear, isLinear, isVod, isVodOrLive} = value.media;

        const className = composeTokenList([
            styles.bar,
            [areControlsIdle, styles.barIdle],
            [isLinear, styles.barLinear]
        ]);

        const testId = composeTokenList([
            TestIds.PLAYER_BAR,
            [!areControlsIdle, TestIds.PLAYER_BAR_VISIBLE]
        ]);

        return (
            <div
                className={className}
                data-test-id={renderTestId(testId)}
            >
                <VolumeControl uiEvents$={uiEvents$} areControlsIdle={areControlsIdle}/>
                {isVodOrLive && <CurrentTime areControlsIdle={areControlsIdle}/>}
                {isVodOrLive && <Timeline uiEvents$={uiEvents$} areControlsIdle={areControlsIdle}/>}
                {isVod && <Timecode uiEvents$={uiEvents$} areControlsIdle={areControlsIdle}/>}
                {isLiveOrLinear && <LiveIndicator
                    uiEvents$={uiEvents$}
                    areControlsIdle={areControlsIdle}
                />}
                <CaptionsMenuButton uiEvents$={uiEvents$} areControlsIdle={areControlsIdle}/>
                <Fullscreen uiEvents$={uiEvents$} areControlsIdle={areControlsIdle}/>
            </div>
        );
    }
}

export default Bar;